import { useState, useEffect } from 'react';

export const useSavedQuotes = () => {
  const [savedQuotes, setSavedQuotes] = useState([]);

  useEffect(() => {
    const quotes = localStorage.getItem('savedQuotes');
    if (quotes) {
      setSavedQuotes(JSON.parse(quotes));
    }
  }, []);

  const saveQuote = (quoteData) => {
    const newQuote = {
      id: Date.now(),
      date: new Date().toISOString(),
      amount: quoteData.summary.finalTotal, // Add this for direct access
      quote: {
        summary: quoteData.summary,
        infrastructure: quoteData.infrastructure,
        support: quoteData.support
      },
      state: quoteData.state
    };
    
    const updatedQuotes = [...savedQuotes, newQuote];
    localStorage.setItem('savedQuotes', JSON.stringify(updatedQuotes));
    setSavedQuotes(updatedQuotes);
  };

  const deleteQuote = (id) => {
    const updatedQuotes = savedQuotes.filter(quote => quote.id !== id);
    localStorage.setItem('savedQuotes', JSON.stringify(updatedQuotes));
    setSavedQuotes(updatedQuotes);
  };

  return { savedQuotes, saveQuote, deleteQuote };
};
